import React,{useEffect, useState}  from "react";
import {   Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
useDisclosure,
FormControl,
FormLabel,
Button,
Input,
Flex,
Alert,
AlertDescription,
AlertIcon,
AlertTitle} from "@chakra-ui/react";
 
import "./popup.css"
import { useLocation, useNavigate } from "react-router";
function Payment(){
    function InitialFocus() {
        const { isOpen, onOpen, onClose } = useDisclosure()
        const [amount, setAmount] = useState(1500)
      
        const initialRef = React.useRef(null)
        const finalRef = React.useRef(null)
        const navigate = useNavigate();

        function getAmount(val){
            setAmount(val.target.value)
        }
        function alt(){
            navigate("/final",{replace:true})
      }
      const location = useLocation();
      const prevPath = location?.state?.from?.pathname || "/"
      console.log(prevPath)
      const close = () => {
        return navigate(prevPath,{replace:true})
      }
      useEffect(()=>{onOpen()},[])
        return (
            <div >
          <>
            <Modal
            blockScrollOnMount={false}
              initialFocusRef={initialRef}
              finalFocusRef={finalRef}
              isOpen={isOpen}
              onClose={onClose}
            >
              <ModalOverlay />
              <ModalContent  className="popup">
                <ModalHeader bg="#01bfbd" color="#fff">Enter card details</ModalHeader>
                
                  <ModalCloseButton onClick={close} color='black' />
                
                <ModalBody pb={3}>
                <FormControl mt={2}>
                    <FormLabel>Card Number</FormLabel>
                    <Input type='number' onChange={getAmount} placeholder='Enter card number' />
                  </FormControl>
                </ModalBody>
                <ModalBody pb={6}>
                  <FormControl>
                    <FormLabel>Name</FormLabel>
                    <Input ref={initialRef} placeholder='Enter name on card' />
                  </FormControl>
      
                  <FormControl mt={4}>
                    <FormLabel>Pin</FormLabel>
                    <Input type="password" placeholder='pin' maxLength={3} width='100px' marginLeft='-72%'/>
                  </FormControl>
                  <FormControl mt={4}>
                    <FormLabel>Expiry Date</FormLabel>
                    <Input placeholder='DD-MM-YY' />
                  </FormControl>
                </ModalBody>
      
                <ModalFooter  >
                    <div className="popup">
                  <Button bg="#01bfbd" color="#fff" onClick={alt} colorScheme='blue' mr={3}>
                    Confirm your payment
                  </Button>
                  <Button bg="#01bfbd" color="#fff" onClick={onClose} colorScheme='blue'>Cancel</Button>
                  </div>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </>
          </div>
        )
        
      }
    return(
        <div  >
      <InitialFocus/>
        </div>
    )
}
export default Payment;